export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  participants: Array<CalendarEventParticipant>;
  priority: CallendarEventPriority;
  startTime: Scalars['DateTime']['output'];
  status: CallendarEventStatus;
  type: CalendarEventType;
};


export type CalendarEventParticipantsArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type CalendarEventChangeResult = {
  __typename?: 'CalendarEventChangeResult';
  payload: CalendarEvent;
  type: EntityChangeType;
};

export type CalendarEventParticipant = {
  __typename?: 'CalendarEventParticipant';
  calendarEvent: CalendarEvent;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
};

export type CalendarEventParticipantChangeResult = {
  __typename?: 'CalendarEventParticipantChangeResult';
  payload: CalendarEventParticipant;
  type: EntityChangeType;
};

export type CalendarEventParticipantsPaginatedResult = {
  __typename?: 'CalendarEventParticipantsPaginatedResult';
  items: Array<CalendarEventParticipant>;
  pageInfo: PageInfo;
};

export enum CalendarEventType {
  Carriage = 'CARRIAGE',
  Delivery = 'DELIVERY',
  Installation = 'INSTALLATION',
  Layout = 'LAYOUT',
  Meeting = 'MEETING',
  Other = 'OTHER'
}

export type CalendarEventsPaginatedResult = {
  __typename?: 'CalendarEventsPaginatedResult';
  items: Array<CalendarEvent>;
  pageInfo: PageInfo;
};

export enum CallendarEventPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum CallendarEventStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Planned = 'PLANNED'
}

export type ChangeOrderStateInput = {
  createTasks: Scalars['Boolean']['input'];
  order: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

/** Comparative operator for queries */
export enum ComparativeOperator {
  Contains = 'CONTAINS',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE'
}

export type Complain = {
  __typename?: 'Complain';
  attachments: Array<StoredFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  done: Scalars['Boolean']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  protocol: Protocol;
  text: Scalars['String']['output'];
};

export type ComplainChangeResult = {
  __typename?: 'ComplainChangeResult';
  payload: Complain;
  type: EntityChangeType;
};

export type ComplainsPaginatedResult = {
  __typename?: 'ComplainsPaginatedResult';
  items: Array<Complain>;
  pageInfo: PageInfo;
};

export type Contract = {
  __typename?: 'Contract';
  contractCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerCity: Scalars['String']['output'];
  customerEmail: Scalars['String']['output'];
  customerHouseNumber: Scalars['String']['output'];
  customerIdentificationNumber?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  customerPhone: Scalars['String']['output'];
  customerResponsiblePerson?: Maybe<Scalars['String']['output']>;
  customerStreet: Scalars['String']['output'];
  customerZip: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  floorplanN1?: Maybe<StoredFile>;
  floorplanN2?: Maybe<StoredFile>;
  floorplanN3?: Maybe<StoredFile>;
  floorplanN4?: Maybe<StoredFile>;
  formOfPayment: PaymentType;
  id: Scalars['String']['output'];
  maxDeliveryDays?: Maybe<Scalars['Float']['output']>;
  obligationAssembleElectronicsFromThem: Scalars['Boolean']['output'];
  obligationDeliverAssembleElectronicsFromUs: Scalars['Boolean']['output'];
  obligationDeliverAssembleFurnitureFromUs: Scalars['Boolean']['output'];
  order: Order;
  orderCity: Scalars['String']['output'];
  orderHouseNumber: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderStreet: Scalars['String']['output'];
  orderZip: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  sellerName: Scalars['String']['output'];
  visualisationN1?: Maybe<StoredFile>;
  visualisationN2?: Maybe<StoredFile>;
};

export type ContractChangeResult = {
  __typename?: 'ContractChangeResult';
  payload: Contract;
  type: EntityChangeType;
};

export type ContractsPaginatedResult = {
  __typename?: 'ContractsPaginatedResult';
  items: Array<Contract>;
  pageInfo: PageInfo;
};

export type CreateCalendarEventInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  priority: CallendarEventPriority;
  startTime: Scalars['String']['input'];
  status: CallendarEventStatus;
  type: CalendarEventType;
};

export type CreateCalendarEventParticipantInput = {
  calendarEvent: Scalars['String']['input'];
  participantId: Scalars['String']['input'];
};

export type CreateComplainInput = {
  protocol: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CreateContractInput = {
  contractCode?: InputMaybe<Scalars['String']['input']>;
  customerCity: Scalars['String']['input'];
  customerEmail: Scalars['String']['input'];
  customerHouseNumber: Scalars['String']['input'];
  customerIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  customerPhone: Scalars['String']['input'];
  customerResponsiblePerson?: InputMaybe<Scalars['String']['input']>;
  customerStreet: Scalars['String']['input'];
  customerZip: Scalars['String']['input'];
  expectedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  floorplanN1?: InputMaybe<Scalars['String']['input']>;
  floorplanN2?: InputMaybe<Scalars['String']['input']>;
  floorplanN3?: InputMaybe<Scalars['String']['input']>;
  floorplanN4?: InputMaybe<Scalars['String']['input']>;
  formOfPayment: PaymentType;
  maxDeliveryDays?: InputMaybe<Scalars['Float']['input']>;
  obligationAssembleElectronicsFromThem: Scalars['Boolean']['input'];
  obligationDeliverAssembleElectronicsFromUs: Scalars['Boolean']['input'];
  obligationDeliverAssembleFurnitureFromUs: Scalars['Boolean']['input'];
  order: Scalars['String']['input'];
  orderCity: Scalars['String']['input'];
  orderHouseNumber: Scalars['String']['input'];
  orderName: Scalars['String']['input'];
  orderStreet: Scalars['String']['input'];
  orderZip: Scalars['String']['input'];
  sellerName: Scalars['String']['input'];
  visualisationN1?: InputMaybe<Scalars['String']['input']>;
  visualisationN2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomItemInput = {
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type CreateCustomerInput = {
  city: Scalars['String']['input'];
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateElectronicInput = {
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  size: Scalars['String']['input'];
  vatType?: InputMaybe<VatType>;
};

export type CreateElectronicOrderPriceInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  customItem?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  electronic?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderPrice: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type CreateFinanceInput = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  expenditure: Scalars['Float']['input'];
  income: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['String']['input'];
};

export type CreateFurnitureInput = {
  manufacturer: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  productLine: Scalars['String']['input'];
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
  withoutDiscount: Scalars['Boolean']['input'];
};

export type CreateFurnitureOrderPriceInput = {
  atypicalTax?: InputMaybe<Scalars['Float']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  customItem?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  furniture?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderPrice: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  productLine?: InputMaybe<Scalars['String']['input']>;
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
  withoutDiscount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateNoteInput = {
  customer?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type CreateNotificationReadInput = {
  notification: Scalars['String']['input'];
};

export type CreateOrderInput = {
  assembly: Scalars['Boolean']['input'];
  assignee?: InputMaybe<Scalars['String']['input']>;
  carpenter?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  customer: Scalars['String']['input'];
  dateOfDelivery?: InputMaybe<Scalars['String']['input']>;
  dateOfInstalation?: InputMaybe<Scalars['String']['input']>;
  dateOfOrder?: InputMaybe<Scalars['String']['input']>;
  dateOfRealization?: InputMaybe<Scalars['String']['input']>;
  dateOfSignature?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfSurvey?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderState?: InputMaybe<Scalars['String']['input']>;
  ownAppliance?: InputMaybe<Scalars['Boolean']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  preliminaryBudget?: InputMaybe<Scalars['Float']['input']>;
  seller?: InputMaybe<Scalars['String']['input']>;
  shipping: Scalars['Boolean']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderPriceInput = {
  backsplashDecor?: InputMaybe<Scalars['String']['input']>;
  colorOfCorpus?: InputMaybe<Scalars['String']['input']>;
  colorOfDoors?: InputMaybe<Scalars['String']['input']>;
  corpusDecor?: InputMaybe<Scalars['String']['input']>;
  corpusMaterial?: InputMaybe<Scalars['String']['input']>;
  discountFurniture?: InputMaybe<Scalars['String']['input']>;
  doorDecor?: InputMaybe<Scalars['String']['input']>;
  doorMaterial?: InputMaybe<Scalars['String']['input']>;
  furnitureSectionName: Scalars['String']['input'];
  handle1Type?: InputMaybe<Scalars['String']['input']>;
  handle2Type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['String']['input'];
  other?: InputMaybe<Scalars['String']['input']>;
  socketType?: InputMaybe<Scalars['String']['input']>;
  socleHeight?: InputMaybe<Scalars['String']['input']>;
  worktopDecor?: InputMaybe<Scalars['String']['input']>;
  worktopType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderStateInput = {
  color: Scalars['String']['input'];
  dashboardIndex?: InputMaybe<Scalars['Int']['input']>;
  finalState: Scalars['Boolean']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderIndex: Scalars['Int']['input'];
  visibleForConstructer: Scalars['Boolean']['input'];
};

export type CreatePartnerInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  contactPersonName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProtocolFieldExtensionInput = {
  label: Scalars['String']['input'];
  protocol: Scalars['String']['input'];
  type: FieldType;
  value: Scalars['Boolean']['input'];
};

export type CreateProtocolInput = {
  carpenterAfterSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  carpenterBeforeSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerAfterSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerBeforeSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  damagedFloor?: InputMaybe<Scalars['Boolean']['input']>;
  damagedGear?: InputMaybe<Scalars['Boolean']['input']>;
  damagedWalls?: InputMaybe<Scalars['Boolean']['input']>;
  fieldExtensions?: InputMaybe<Array<CreateProtocolFieldExtensionInput>>;
  fumeHoodIsCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  halfTimeOfSpaceIsEqual?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['String']['input'];
  preparationOfElectroInstalationIsCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  protocolHandoverContractorState?: InputMaybe<ProtocolHandoverContractorState>;
  protocolResultState?: InputMaybe<ProtocolResultState>;
  waterAndWasteOutletIsCorrect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateServiceInput = {
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type CreateServiceOrderPriceInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  customItem?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderPrice: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type CreateTaskInput = {
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  due: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  priority: TaskPriority;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  state: TaskState;
};

export type CreateTaskPresetInput = {
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  dayOffset: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderState: Scalars['String']['input'];
  priority: TaskPriority;
};

export type CreateTodoInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type CustomItem = {
  __typename?: 'CustomItem';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  electronicOrderPrices: Array<ElectronicOrderPrice>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  sellerPrice?: Maybe<Scalars['Float']['output']>;
  serviceOrderPrices: Array<ServiceOrderPrice>;
  vatType?: Maybe<VatType>;
};


export type CustomItemElectronicOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type CustomItemChangeResult = {
  __typename?: 'CustomItemChangeResult';
  payload: CustomItem;
  type: EntityChangeType;
};

export type CustomItemsPaginatedResult = {
  __typename?: 'CustomItemsPaginatedResult';
  items: Array<CustomItem>;
  pageInfo: PageInfo;
};

export type Customer = {
  __typename?: 'Customer';
  city: Scalars['String']['output'];
  contactPersonName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  documents: Array<StoredFile>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  notes: Array<Note>;
  orders: Array<Order>;
  organizationId: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  phone: Scalars['String']['output'];
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type CustomerDocumentsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type CustomerNotesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type CustomerOrdersArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type CustomerChangeResult = {
  __typename?: 'CustomerChangeResult';
  payload: Customer;
  type: EntityChangeType;
};

export type CustomersPaginatedResult = {
  __typename?: 'CustomersPaginatedResult';
  items: Array<Customer>;
  pageInfo: PageInfo;
};

export type Electronic = {
  __typename?: 'Electronic';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  electronicOrderPrices: Array<ElectronicOrderPrice>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  sellerPrice?: Maybe<Scalars['Float']['output']>;
  size: Scalars['String']['output'];
  vatType?: Maybe<VatType>;
};


export type ElectronicElectronicOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type ElectronicChangeResult = {
  __typename?: 'ElectronicChangeResult';
  payload: Electronic;
  type: EntityChangeType;
};

export type ElectronicOrderPrice = {
  __typename?: 'ElectronicOrderPrice';
  count?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customItem?: Maybe<CustomItem>;
  discount?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  electronic?: Maybe<Electronic>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderPrice: OrderPrice;
  organizationId: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  sellerPrice?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  vatType?: Maybe<VatType>;
};

export type ElectronicOrderPriceChangeResult = {
  __typename?: 'ElectronicOrderPriceChangeResult';
  payload: ElectronicOrderPrice;
  type: EntityChangeType;
};

export type ElectronicOrderPricesPaginatedResult = {
  __typename?: 'ElectronicOrderPricesPaginatedResult';
  items: Array<ElectronicOrderPrice>;
  pageInfo: PageInfo;
};

export type ElectronicsPaginatedResult = {
  __typename?: 'ElectronicsPaginatedResult';
  items: Array<Electronic>;
  pageInfo: PageInfo;
};

export enum EntityChangeType {
  Remove = 'REMOVE',
  Update = 'UPDATE'
}

export enum FieldType {
  After = 'AFTER',
  Before = 'BEFORE'
}

export type FilterInput = {
  filterItems?: InputMaybe<Array<FilterItem>>;
  orderItems?: InputMaybe<Array<OrderItem>>;
};

export type FilterItem = {
  /** query comparative operator */
  CO?: ComparativeOperator;
  /** query logical operator */
  LO?: LogicalOperator;
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Finance = {
  __typename?: 'Finance';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  expenditure: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  income: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  order: Order;
  organizationId: Scalars['String']['output'];
  partner: Order;
};

export type FinanceChangeResult = {
  __typename?: 'FinanceChangeResult';
  payload: Finance;
  type: EntityChangeType;
};

export type FinancesPaginatedResult = {
  __typename?: 'FinancesPaginatedResult';
  items: Array<Finance>;
  pageInfo: PageInfo;
};

export type Furniture = {
  __typename?: 'Furniture';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  electronicOrderPrices: Array<FurnitureOrderPrice>;
  furnitureOrderPrices: Array<FurnitureOrderPrice>;
  id: Scalars['String']['output'];
  manufacturer: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  productLine: Scalars['String']['output'];
  sellerPrice?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  vatType?: Maybe<VatType>;
  withoutDiscount: Scalars['Boolean']['output'];
};


export type FurnitureElectronicOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type FurnitureChangeResult = {
  __typename?: 'FurnitureChangeResult';
  payload: Furniture;
  type: EntityChangeType;
};

export type FurnitureOrderPrice = {
  __typename?: 'FurnitureOrderPrice';
  atypicalTax?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customItem?: Maybe<CustomItem>;
  discount?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  furniture?: Maybe<Furniture>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orderPrice: OrderPrice;
  organizationId: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  productLine?: Maybe<Scalars['String']['output']>;
  sellerPrice?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  vatType?: Maybe<VatType>;
  withoutDiscount: Scalars['Boolean']['output'];
};

export type FurnitureOrderPriceChangeResult = {
  __typename?: 'FurnitureOrderPriceChangeResult';
  payload: FurnitureOrderPrice;
  type: EntityChangeType;
};

export type FurnitureOrderPricesPaginatedResult = {
  __typename?: 'FurnitureOrderPricesPaginatedResult';
  items: Array<FurnitureOrderPrice>;
  pageInfo: PageInfo;
};

export type FurnituresPaginatedResult = {
  __typename?: 'FurnituresPaginatedResult';
  items: Array<Furniture>;
  pageInfo: PageInfo;
};

/** Logical operator for queries */
export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export type Mutation = {
  __typename?: 'Mutation';
  changeOrderState: Order;
  cloneOrderPrice: OrderPrice;
  createCalendarEvent: CalendarEvent;
  createCalendarEventParticipant: CalendarEventParticipant;
  createCalendarEventParticipants: Array<CalendarEventParticipant>;
  createCalendarEvents: Array<CalendarEvent>;
  createComplain: Complain;
  createComplains: Array<Complain>;
  createContract: Contract;
  createContracts: Array<Contract>;
  createCustomItem: CustomItem;
  createCustomItems: Array<CustomItem>;
  createCustomer: Customer;
  createCustomers: Array<Customer>;
  createElectronic: Electronic;
  createElectronicOrderPrice: ElectronicOrderPrice;
  createElectronicOrderPrices: Array<ElectronicOrderPrice>;
  createElectronics: Array<Electronic>;
  createFinance: Finance;
  createFinances: Array<Finance>;
  createFurniture: Furniture;
  createFurnitureOrderPrice: FurnitureOrderPrice;
  createFurnitureOrderPrices: Array<FurnitureOrderPrice>;
  createFurnitures: Array<Furniture>;
  createNote: Note;
  createNotes: Array<Note>;
  /** @deprecated not createable through resolver */
  createNotification: Notification;
  createNotificationRead: NotificationRead;
  createNotificationReads: Array<NotificationRead>;
  /** @deprecated not createable through resolver */
  createNotifications: Array<Notification>;
  createOrder: Order;
  /** @deprecated not createable through resolver */
  createOrderDocument: OrderDocument;
  /** @deprecated not createable through resolver */
  createOrderDocuments: Array<OrderDocument>;
  createOrderPrice: OrderPrice;
  createOrderPrices: Array<OrderPrice>;
  createOrderState: OrderState;
  createOrderStates: Array<OrderState>;
  createOrders: Array<Order>;
  createPartner: Partner;
  createPartners: Array<Partner>;
  createProtocol: Protocol;
  createProtocolFieldExtension: ProtocolFieldExtension;
  createProtocolFieldExtensions: Array<ProtocolFieldExtension>;
  createProtocols: Array<Protocol>;
  createService: Service;
  createServiceOrderPrice: ServiceOrderPrice;
  createServiceOrderPrices: Array<ServiceOrderPrice>;
  createServices: Array<Service>;
  createTask: Task;
  createTaskPreset: TaskPreset;
  createTaskPresets: Array<TaskPreset>;
  createTasks: Array<Task>;
  createTodo: Todo;
  createTodos: Array<Todo>;
  readNotifications: Array<NotificationRead>;
  removeCalendarEvent: CalendarEvent;
  removeCalendarEventParticipant: CalendarEventParticipant;
  removeCalendarEventParticipants: Array<CalendarEventParticipant>;
  removeCalendarEvents: Array<CalendarEvent>;
  removeComplain: Complain;
  removeComplains: Array<Complain>;
  removeContract: Contract;
  removeContracts: Array<Contract>;
  removeCustomItem: CustomItem;
  removeCustomItems: Array<CustomItem>;
  removeCustomer: Customer;
  removeCustomers: Array<Customer>;
  removeElectronic: Electronic;
  removeElectronicOrderPrice: ElectronicOrderPrice;
  removeElectronicOrderPrices: Array<ElectronicOrderPrice>;
  removeElectronics: Array<Electronic>;
  removeFinance: Finance;
  removeFinances: Array<Finance>;
  removeFurniture: Furniture;
  removeFurnitureOrderPrice: FurnitureOrderPrice;
  removeFurnitureOrderPrices: Array<FurnitureOrderPrice>;
  removeFurnitures: Array<Furniture>;
  removeNote: Note;
  removeNotes: Array<Note>;
  removeNotification: Notification;
  removeNotificationRead: NotificationRead;
  removeNotificationReads: Array<NotificationRead>;
  removeNotifications: Array<Notification>;
  removeOrder: Order;
  removeOrderDocument: OrderDocument;
  removeOrderDocuments: Array<OrderDocument>;
  removeOrderPrice: OrderPrice;
  removeOrderPrices: Array<OrderPrice>;
  removeOrderState: OrderState;
  removeOrderStates: Array<OrderState>;
  removeOrders: Array<Order>;
  removePartner: Partner;
  removePartners: Array<Partner>;
  removeProtocol: Protocol;
  removeProtocolFieldExtension: ProtocolFieldExtension;
  removeProtocolFieldExtensions: Array<ProtocolFieldExtension>;
  removeProtocols: Array<Protocol>;
  removeService: Service;
  removeServiceOrderPrice: ServiceOrderPrice;
  removeServiceOrderPrices: Array<ServiceOrderPrice>;
  removeServices: Array<Service>;
  removeTask: Task;
  removeTaskPreset: TaskPreset;
  removeTaskPresets: Array<TaskPreset>;
  removeTasks: Array<Task>;
  removeTodo: Todo;
  removeTodos: Array<Todo>;
  updateCalendarEvent: CalendarEvent;
  updateCalendarEventParticipant: CalendarEventParticipant;
  updateCalendarEventParticipants: Array<CalendarEventParticipant>;
  updateCalendarEvents: Array<CalendarEvent>;
  updateComplain: Complain;
  updateComplains: Array<Complain>;
  updateContract: Contract;
  updateContracts: Array<Contract>;
  updateCustomItem: CustomItem;
  updateCustomItems: Array<CustomItem>;
  updateCustomer: Customer;
  updateCustomers: Array<Customer>;
  updateElectronic: Electronic;
  updateElectronicOrderPrice: ElectronicOrderPrice;
  updateElectronicOrderPrices: Array<ElectronicOrderPrice>;
  updateElectronics: Array<Electronic>;
  updateFinance: Finance;
  updateFinances: Array<Finance>;
  updateFurniture: Furniture;
  updateFurnitureOrderPrice: FurnitureOrderPrice;
  updateFurnitureOrderPrices: Array<FurnitureOrderPrice>;
  updateFurnitures: Array<Furniture>;
  updateNote: Note;
  updateNotes: Array<Note>;
  updateNotification: Notification;
  updateNotificationRead: NotificationRead;
  updateNotificationReads: Array<NotificationRead>;
  updateNotifications: Array<Notification>;
  updateOrder: Order;
  updateOrderDocument: OrderDocument;
  updateOrderDocuments: Array<OrderDocument>;
  updateOrderPrice: OrderPrice;
  updateOrderPrices: Array<OrderPrice>;
  updateOrderState: OrderState;
  updateOrderStates: Array<OrderState>;
  updateOrders: Array<Order>;
  updatePartner: Partner;
  updatePartners: Array<Partner>;
  updateProtocol: Protocol;
  updateProtocolFieldExtension: ProtocolFieldExtension;
  updateProtocolFieldExtensions: Array<ProtocolFieldExtension>;
  updateProtocols: Array<Protocol>;
  updateService: Service;
  updateServiceOrderPrice: ServiceOrderPrice;
  updateServiceOrderPrices: Array<ServiceOrderPrice>;
  updateServices: Array<Service>;
  updateTask: Task;
  updateTaskPreset: TaskPreset;
  updateTaskPresets: Array<TaskPreset>;
  updateTasks: Array<Task>;
  updateTodo: Todo;
  updateTodos: Array<Todo>;
};


export type MutationChangeOrderStateArgs = {
  changeOrderStateInput: ChangeOrderStateInput;
};


export type MutationCloneOrderPriceArgs = {
  orderPriceId: Scalars['String']['input'];
};


export type MutationCreateCalendarEventArgs = {
  createCalendarEventInput: CreateCalendarEventInput;
};


export type MutationCreateCalendarEventParticipantArgs = {
  createCalendarEventParticipantInput: CreateCalendarEventParticipantInput;
};


export type MutationCreateCalendarEventParticipantsArgs = {
  createCalendarEventParticipantsInput: Array<CreateCalendarEventParticipantInput>;
};


export type MutationCreateCalendarEventsArgs = {
  createCalendarEventsInput: Array<CreateCalendarEventInput>;
};


export type MutationCreateComplainArgs = {
  createComplainInput: CreateComplainInput;
};


export type MutationCreateComplainsArgs = {
  createComplainsInput: Array<CreateComplainInput>;
};


export type MutationCreateContractArgs = {
  createContractInput: CreateContractInput;
};


export type MutationCreateContractsArgs = {
  createContractsInput: Array<CreateContractInput>;
};


export type MutationCreateCustomItemArgs = {
  createCustomItemInput: CreateCustomItemInput;
};


export type MutationCreateCustomItemsArgs = {
  createCustomItemsInput: Array<CreateCustomItemInput>;
};


export type MutationCreateCustomerArgs = {
  createCustomerInput: CreateCustomerInput;
};


export type MutationCreateCustomersArgs = {
  createCustomersInput: Array<CreateCustomerInput>;
};


export type MutationCreateElectronicArgs = {
  createElectronicInput: CreateElectronicInput;
};


export type MutationCreateElectronicOrderPriceArgs = {
  createElectronicOrderPriceInput: CreateElectronicOrderPriceInput;
};


export type MutationCreateElectronicOrderPricesArgs = {
  createElectronicOrderPricesInput: Array<CreateElectronicOrderPriceInput>;
};


export type MutationCreateElectronicsArgs = {
  createElectronicsInput: Array<CreateElectronicInput>;
};


export type MutationCreateFinanceArgs = {
  createFinanceInput: CreateFinanceInput;
};


export type MutationCreateFinancesArgs = {
  createFinancesInput: Array<CreateFinanceInput>;
};


export type MutationCreateFurnitureArgs = {
  createFurnitureInput: CreateFurnitureInput;
};


export type MutationCreateFurnitureOrderPriceArgs = {
  createFurnitureOrderPriceInput: CreateFurnitureOrderPriceInput;
};


export type MutationCreateFurnitureOrderPricesArgs = {
  createFurnitureOrderPricesInput: Array<CreateFurnitureOrderPriceInput>;
};


export type MutationCreateFurnituresArgs = {
  createFurnituresInput: Array<CreateFurnitureInput>;
};


export type MutationCreateNoteArgs = {
  createNoteInput: CreateNoteInput;
};


export type MutationCreateNotesArgs = {
  createNotesInput: Array<CreateNoteInput>;
};


export type MutationCreateNotificationReadArgs = {
  createNotificationReadInput: CreateNotificationReadInput;
};


export type MutationCreateNotificationReadsArgs = {
  createNotificationReadsInput: Array<CreateNotificationReadInput>;
};


export type MutationCreateOrderArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationCreateOrderPriceArgs = {
  createOrderPriceInput: CreateOrderPriceInput;
};


export type MutationCreateOrderPricesArgs = {
  createOrderPricesInput: Array<CreateOrderPriceInput>;
};


export type MutationCreateOrderStateArgs = {
  createOrderStateInput: CreateOrderStateInput;
};


export type MutationCreateOrderStatesArgs = {
  createOrderStatesInput: Array<CreateOrderStateInput>;
};


export type MutationCreateOrdersArgs = {
  createOrdersInput: Array<CreateOrderInput>;
};


export type MutationCreatePartnerArgs = {
  createPartnerInput: CreatePartnerInput;
};


export type MutationCreatePartnersArgs = {
  createPartnersInput: Array<CreatePartnerInput>;
};


export type MutationCreateProtocolArgs = {
  createProtocolInput: CreateProtocolInput;
};


export type MutationCreateProtocolFieldExtensionArgs = {
  createProtocolFieldExtensionInput: CreateProtocolFieldExtensionInput;
};


export type MutationCreateProtocolFieldExtensionsArgs = {
  createProtocolFieldExtensionsInput: Array<CreateProtocolFieldExtensionInput>;
};


export type MutationCreateProtocolsArgs = {
  createProtocolsInput: Array<CreateProtocolInput>;
};


export type MutationCreateServiceArgs = {
  createServiceInput: CreateServiceInput;
};


export type MutationCreateServiceOrderPriceArgs = {
  createServiceOrderPriceInput: CreateServiceOrderPriceInput;
};


export type MutationCreateServiceOrderPricesArgs = {
  createServiceOrderPricesInput: Array<CreateServiceOrderPriceInput>;
};


export type MutationCreateServicesArgs = {
  createServicesInput: Array<CreateServiceInput>;
};


export type MutationCreateTaskArgs = {
  createTaskInput: CreateTaskInput;
};


export type MutationCreateTaskPresetArgs = {
  createTaskPresetInput: CreateTaskPresetInput;
};


export type MutationCreateTaskPresetsArgs = {
  createTaskPresetsInput: Array<CreateTaskPresetInput>;
};


export type MutationCreateTasksArgs = {
  createTasksInput: Array<CreateTaskInput>;
};


export type MutationCreateTodoArgs = {
  createTodoInput: CreateTodoInput;
};


export type MutationCreateTodosArgs = {
  createTodosInput: Array<CreateTodoInput>;
};


export type MutationReadNotificationsArgs = {
  readNotificationsInput: Array<ReadNotificationInput>;
};


export type MutationRemoveCalendarEventArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCalendarEventParticipantArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCalendarEventParticipantsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveCalendarEventsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveComplainArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveComplainsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveContractArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveContractsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveCustomItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCustomItemsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCustomersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveElectronicArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveElectronicOrderPriceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveElectronicOrderPricesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveElectronicsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveFinanceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveFinancesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveFurnitureArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveFurnitureOrderPriceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveFurnitureOrderPricesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveFurnituresArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveNotesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveNotificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveNotificationReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveNotificationReadsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveNotificationsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveOrderArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveOrderDocumentArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveOrderDocumentsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveOrderPriceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveOrderPricesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveOrderStateArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveOrderStatesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveOrdersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemovePartnerArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePartnersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveProtocolArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProtocolFieldExtensionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProtocolFieldExtensionsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveProtocolsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveServiceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveServiceOrderPriceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveServiceOrderPricesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveServicesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveTaskPresetArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveTaskPresetsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveTasksArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveTodoArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveTodosArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationUpdateCalendarEventArgs = {
  updateCalendarEventInput: UpdateCalendarEventInput;
};


export type MutationUpdateCalendarEventParticipantArgs = {
  updateCalendarEventParticipantInput: UpdateCalendarEventParticipantInput;
};


export type MutationUpdateCalendarEventParticipantsArgs = {
  updateCalendarEventParticipantsInput: Array<UpdateCalendarEventParticipantInput>;
};


export type MutationUpdateCalendarEventsArgs = {
  updateCalendarEventsInput: Array<UpdateCalendarEventInput>;
};


export type MutationUpdateComplainArgs = {
  updateComplainInput: UpdateComplainInput;
};


export type MutationUpdateComplainsArgs = {
  updateComplainsInput: Array<UpdateComplainInput>;
};


export type MutationUpdateContractArgs = {
  updateContractInput: UpdateContractInput;
};


export type MutationUpdateContractsArgs = {
  updateContractsInput: Array<UpdateContractInput>;
};


export type MutationUpdateCustomItemArgs = {
  updateCustomItemInput: UpdateCustomItemInput;
};


export type MutationUpdateCustomItemsArgs = {
  updateCustomItemsInput: Array<UpdateCustomItemInput>;
};


export type MutationUpdateCustomerArgs = {
  updateCustomerInput: UpdateCustomerInput;
};


export type MutationUpdateCustomersArgs = {
  updateCustomersInput: Array<UpdateCustomerInput>;
};


export type MutationUpdateElectronicArgs = {
  updateElectronicInput: UpdateElectronicInput;
};


export type MutationUpdateElectronicOrderPriceArgs = {
  updateElectronicOrderPriceInput: UpdateElectronicOrderPriceInput;
};


export type MutationUpdateElectronicOrderPricesArgs = {
  updateElectronicOrderPricesInput: Array<UpdateElectronicOrderPriceInput>;
};


export type MutationUpdateElectronicsArgs = {
  updateElectronicsInput: Array<UpdateElectronicInput>;
};


export type MutationUpdateFinanceArgs = {
  updateFinanceInput: UpdateFinanceInput;
};


export type MutationUpdateFinancesArgs = {
  updateFinancesInput: Array<UpdateFinanceInput>;
};


export type MutationUpdateFurnitureArgs = {
  updateFurnitureInput: UpdateFurnitureInput;
};


export type MutationUpdateFurnitureOrderPriceArgs = {
  updateFurnitureOrderPriceInput: UpdateFurnitureOrderPriceInput;
};


export type MutationUpdateFurnitureOrderPricesArgs = {
  updateFurnitureOrderPricesInput: Array<UpdateFurnitureOrderPriceInput>;
};


export type MutationUpdateFurnituresArgs = {
  updateFurnituresInput: Array<UpdateFurnitureInput>;
};


export type MutationUpdateNoteArgs = {
  updateNoteInput: UpdateNoteInput;
};


export type MutationUpdateNotesArgs = {
  updateNotesInput: Array<UpdateNoteInput>;
};


export type MutationUpdateNotificationArgs = {
  updateNotificationInput: UpdateNotificationInput;
};


export type MutationUpdateNotificationReadArgs = {
  updateNotificationReadInput: UpdateNotificationReadInput;
};


export type MutationUpdateNotificationReadsArgs = {
  updateNotificationReadsInput: Array<UpdateNotificationReadInput>;
};


export type MutationUpdateNotificationsArgs = {
  updateNotificationsInput: Array<UpdateNotificationInput>;
};


export type MutationUpdateOrderArgs = {
  updateOrderInput: UpdateOrderInput;
};


export type MutationUpdateOrderDocumentArgs = {
  updateOrderDocumentInput: UpdateOrderDocumentInput;
};


export type MutationUpdateOrderDocumentsArgs = {
  updateOrderDocumentsInput: Array<UpdateOrderDocumentInput>;
};


export type MutationUpdateOrderPriceArgs = {
  updateOrderPriceInput: UpdateOrderPriceInput;
};


export type MutationUpdateOrderPricesArgs = {
  updateOrderPricesInput: Array<UpdateOrderPriceInput>;
};


export type MutationUpdateOrderStateArgs = {
  updateOrderStateInput: UpdateOrderStateInput;
};


export type MutationUpdateOrderStatesArgs = {
  updateOrderStatesInput: Array<UpdateOrderStateInput>;
};


export type MutationUpdateOrdersArgs = {
  updateOrdersInput: Array<UpdateOrderInput>;
};


export type MutationUpdatePartnerArgs = {
  updatePartnerInput: UpdatePartnerInput;
};


export type MutationUpdatePartnersArgs = {
  updatePartnersInput: Array<UpdatePartnerInput>;
};


export type MutationUpdateProtocolArgs = {
  updateProtocolInput: UpdateProtocolInput;
};


export type MutationUpdateProtocolFieldExtensionArgs = {
  updateProtocolFieldExtensionInput: UpdateProtocolFieldExtensionInput;
};


export type MutationUpdateProtocolFieldExtensionsArgs = {
  updateProtocolFieldExtensionsInput: Array<UpdateProtocolFieldExtensionInput>;
};


export type MutationUpdateProtocolsArgs = {
  updateProtocolsInput: Array<UpdateProtocolInput>;
};


export type MutationUpdateServiceArgs = {
  updateServiceInput: UpdateServiceInput;
};


export type MutationUpdateServiceOrderPriceArgs = {
  updateServiceOrderPriceInput: UpdateServiceOrderPriceInput;
};


export type MutationUpdateServiceOrderPricesArgs = {
  updateServiceOrderPricesInput: Array<UpdateServiceOrderPriceInput>;
};


export type MutationUpdateServicesArgs = {
  updateServicesInput: Array<UpdateServiceInput>;
};


export type MutationUpdateTaskArgs = {
  updateTaskInput: UpdateTaskInput;
};


export type MutationUpdateTaskPresetArgs = {
  updateTaskPresetInput: UpdateTaskPresetInput;
};


export type MutationUpdateTaskPresetsArgs = {
  updateTaskPresetsInput: Array<UpdateTaskPresetInput>;
};


export type MutationUpdateTasksArgs = {
  updateTasksInput: Array<UpdateTaskInput>;
};


export type MutationUpdateTodoArgs = {
  updateTodoInput: UpdateTodoInput;
};


export type MutationUpdateTodosArgs = {
  updateTodosInput: Array<UpdateTodoInput>;
};

export type Note = {
  __typename?: 'Note';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customer: Customer;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Order;
  organizationId: Scalars['String']['output'];
  partner: Partner;
  text: Scalars['String']['output'];
};

export type NoteChangeResult = {
  __typename?: 'NoteChangeResult';
  payload: Note;
  type: EntityChangeType;
};

export type NotesPaginatedResult = {
  __typename?: 'NotesPaginatedResult';
  items: Array<Note>;
  pageInfo: PageInfo;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  type: NotificationType;
};

export type NotificationChangeResult = {
  __typename?: 'NotificationChangeResult';
  payload: Notification;
  type: EntityChangeType;
};

export type NotificationRead = {
  __typename?: 'NotificationRead';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  notification: Notification;
  organizationId: Scalars['String']['output'];
  zitadelUserId: Scalars['String']['output'];
};

export type NotificationReadChangeResult = {
  __typename?: 'NotificationReadChangeResult';
  payload: NotificationRead;
  type: EntityChangeType;
};

export type NotificationReadsPaginatedResult = {
  __typename?: 'NotificationReadsPaginatedResult';
  items: Array<NotificationRead>;
  pageInfo: PageInfo;
};

export enum NotificationType {
  AssemblerComplainChange = 'ASSEMBLER_COMPLAIN_CHANGE',
  AssemblerDocumentsAdded = 'ASSEMBLER_DOCUMENTS_ADDED',
  AssemblerProtocolCreated = 'ASSEMBLER_PROTOCOL_CREATED',
  AssemblerProtocolUpdated = 'ASSEMBLER_PROTOCOL_UPDATED',
  CeoNewCustomerCreated = 'CEO_NEW_CUSTOMER_CREATED',
  CeoNewOrderCreated = 'CEO_NEW_ORDER_CREATED',
  NewCalendarEventCreated = 'NEW_CALENDAR_EVENT_CREATED',
  NewNoteCreated = 'NEW_NOTE_CREATED',
  OrderStateChange = 'ORDER_STATE_CHANGE',
  TraderNewCustomerCreated = 'TRADER_NEW_CUSTOMER_CREATED',
  TraderNewOrderCreated = 'TRADER_NEW_ORDER_CREATED'
}

export type NotificationsPaginatedResult = {
  __typename?: 'NotificationsPaginatedResult';
  items: Array<Notification>;
  pageInfo: PageInfo;
};

export type Order = {
  __typename?: 'Order';
  approximateDateOfRealization?: Maybe<Scalars['DateTime']['output']>;
  assembly: Scalars['Boolean']['output'];
  assignee?: Maybe<Scalars['String']['output']>;
  carpenter?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  contracts: Array<Contract>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customer: Customer;
  dateOfDelivery?: Maybe<Scalars['DateTime']['output']>;
  dateOfInstalation?: Maybe<Scalars['DateTime']['output']>;
  dateOfOrder?: Maybe<Scalars['DateTime']['output']>;
  dateOfRealization?: Maybe<Scalars['DateTime']['output']>;
  dateOfSignature?: Maybe<Scalars['DateTime']['output']>;
  dateOfSurvey?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  finance: Array<Finance>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  invoiceCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Array<Note>;
  orderDocuments: Array<OrderDocument>;
  orderPrices?: Maybe<Array<OrderPrice>>;
  orderState?: Maybe<OrderState>;
  organizationId: Scalars['String']['output'];
  ownAppliance?: Maybe<Scalars['Boolean']['output']>;
  partner?: Maybe<Partner>;
  preliminaryBudget?: Maybe<Scalars['Float']['output']>;
  protocols?: Maybe<Array<Protocol>>;
  seller?: Maybe<Scalars['String']['output']>;
  shipping: Scalars['Boolean']['output'];
  street?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
  todos: Array<Todo>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type OrderContractsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderFinanceArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderNotesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderOrderDocumentsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderProtocolsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderTasksArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderTodosArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type OrderChangeResult = {
  __typename?: 'OrderChangeResult';
  payload: Order;
  type: EntityChangeType;
};

export type OrderDocument = {
  __typename?: 'OrderDocument';
  category: OrderDocumentCategory;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  document: StoredFile;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Order;
  organizationId: Scalars['String']['output'];
  protocol?: Maybe<Protocol>;
};

export enum OrderDocumentCategory {
  ElectroInstalation = 'ELECTRO_INSTALATION',
  Focus = 'FOCUS',
  Fotodocumentation = 'FOTODOCUMENTATION',
  Inventory = 'INVENTORY',
  Other = 'OTHER',
  TechnicalDocuments = 'TECHNICAL_DOCUMENTS',
  TradeDocuments = 'TRADE_DOCUMENTS',
  Visualization = 'VISUALIZATION'
}

export type OrderDocumentChangeResult = {
  __typename?: 'OrderDocumentChangeResult';
  payload: OrderDocument;
  type: EntityChangeType;
};

export type OrderDocumentsPaginatedResult = {
  __typename?: 'OrderDocumentsPaginatedResult';
  items: Array<OrderDocument>;
  pageInfo: PageInfo;
};

export type OrderItem = {
  field: Scalars['String']['input'];
  type?: OrderOperator;
};

/** Order operator for queries */
export enum OrderOperator {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderPrice = {
  __typename?: 'OrderPrice';
  backsplashDecor?: Maybe<Scalars['String']['output']>;
  colorOfCorpus?: Maybe<Scalars['String']['output']>;
  colorOfDoors?: Maybe<Scalars['String']['output']>;
  corpusDecor?: Maybe<Scalars['String']['output']>;
  corpusMaterial?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  discountFurniture?: Maybe<Scalars['String']['output']>;
  doorDecor?: Maybe<Scalars['String']['output']>;
  doorMaterial?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  electronicOrderPrices: Array<ElectronicOrderPrice>;
  furnitureOrderPrices: Array<FurnitureOrderPrice>;
  furnitureSectionName: Scalars['String']['output'];
  handle1Type?: Maybe<Scalars['String']['output']>;
  handle2Type?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceCode: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Order;
  organizationId: Scalars['String']['output'];
  other?: Maybe<Scalars['String']['output']>;
  serviceOrderPrices: Array<ServiceOrderPrice>;
  socketType?: Maybe<Scalars['String']['output']>;
  socleHeight?: Maybe<Scalars['String']['output']>;
  worktopDecor?: Maybe<Scalars['String']['output']>;
  worktopType?: Maybe<Scalars['String']['output']>;
};


export type OrderPriceElectronicOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderPriceFurnitureOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type OrderPriceServiceOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type OrderPriceChangeResult = {
  __typename?: 'OrderPriceChangeResult';
  payload: OrderPrice;
  type: EntityChangeType;
};

export type OrderPricesPaginatedResult = {
  __typename?: 'OrderPricesPaginatedResult';
  items: Array<OrderPrice>;
  pageInfo: PageInfo;
};

export type OrderState = {
  __typename?: 'OrderState';
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dashboardIndex?: Maybe<Scalars['Int']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  finalState: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  visibleForConstructer: Scalars['Boolean']['output'];
};

export type OrderStateChangeResult = {
  __typename?: 'OrderStateChangeResult';
  payload: OrderState;
  type: EntityChangeType;
};

export type OrderStatesPaginatedResult = {
  __typename?: 'OrderStatesPaginatedResult';
  items: Array<OrderState>;
  pageInfo: PageInfo;
};

export type OrdersPaginatedResult = {
  __typename?: 'OrdersPaginatedResult';
  items: Array<Order>;
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentCount: Scalars['Float']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Float']['output'];
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type Partner = {
  __typename?: 'Partner';
  city?: Maybe<Scalars['String']['output']>;
  contactPersonName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customers: Array<Customer>;
  documents: Array<StoredFile>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identificationNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  notes: Array<Note>;
  orders: Array<Order>;
  organizationId: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  street?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type PartnerCustomersArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type PartnerDocumentsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type PartnerNotesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type PartnerOrdersArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type PartnerChangeResult = {
  __typename?: 'PartnerChangeResult';
  payload: Partner;
  type: EntityChangeType;
};

export type PartnersPaginatedResult = {
  __typename?: 'PartnersPaginatedResult';
  items: Array<Partner>;
  pageInfo: PageInfo;
};

export enum PaymentType {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH'
}

export type Protocol = {
  __typename?: 'Protocol';
  accesoriesMatchesContract?: Maybe<Scalars['Boolean']['output']>;
  carpenterAfterSignedAt?: Maybe<Scalars['DateTime']['output']>;
  carpenterBeforeSignedAt?: Maybe<Scalars['DateTime']['output']>;
  carpenterSignatureAfter?: Maybe<Scalars['String']['output']>;
  carpenterSignatureBefore?: Maybe<Scalars['String']['output']>;
  cleanUpIsCompliant?: Maybe<Scalars['Boolean']['output']>;
  colorMatchesContract?: Maybe<Scalars['Boolean']['output']>;
  complains: Array<Complain>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customerAfterSignedAt?: Maybe<Scalars['DateTime']['output']>;
  customerBeforeSignedAt?: Maybe<Scalars['DateTime']['output']>;
  customerSignatureAfter?: Maybe<Scalars['String']['output']>;
  customerSignatureBefore?: Maybe<Scalars['String']['output']>;
  damagedFloor?: Maybe<Scalars['Boolean']['output']>;
  damagedGear?: Maybe<Scalars['Boolean']['output']>;
  damagedWalls?: Maybe<Scalars['Boolean']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  fieldExtensions?: Maybe<Array<ProtocolFieldExtension>>;
  fumeHoodIsCorrect?: Maybe<Scalars['Boolean']['output']>;
  furnitureSetupIsComplete?: Maybe<Scalars['Boolean']['output']>;
  halfTimeOfSpaceIsEqual?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  instalationOfKitchenSetup?: Maybe<Scalars['Boolean']['output']>;
  order: Order;
  organizationId: Scalars['String']['output'];
  preparationOfElectroInstalationIsCorrect?: Maybe<Scalars['Boolean']['output']>;
  protocolDocuments: Array<OrderDocument>;
  protocolHandoverContractorState?: Maybe<ProtocolHandoverContractorState>;
  protocolResultState?: Maybe<ProtocolResultState>;
  visuallyOk?: Maybe<Scalars['Boolean']['output']>;
  waterAndWasteOutletIsCorrect?: Maybe<Scalars['Boolean']['output']>;
};


export type ProtocolComplainsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type ProtocolFieldExtensionsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type ProtocolProtocolDocumentsArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type ProtocolChangeResult = {
  __typename?: 'ProtocolChangeResult';
  payload: Protocol;
  type: EntityChangeType;
};

export type ProtocolFieldExtension = {
  __typename?: 'ProtocolFieldExtension';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  protocol: Protocol;
  type: FieldType;
  value: Scalars['Boolean']['output'];
};

export type ProtocolFieldExtensionChangeResult = {
  __typename?: 'ProtocolFieldExtensionChangeResult';
  payload: ProtocolFieldExtension;
  type: EntityChangeType;
};

export type ProtocolFieldExtensionsPaginatedResult = {
  __typename?: 'ProtocolFieldExtensionsPaginatedResult';
  items: Array<ProtocolFieldExtension>;
  pageInfo: PageInfo;
};

export enum ProtocolHandoverContractorState {
  Reject = 'REJECT',
  Take = 'TAKE',
  TakeButComplain = 'TAKE_BUT_COMPLAIN'
}

export enum ProtocolResultState {
  Reject = 'REJECT',
  Take = 'TAKE',
  TakeButComplain = 'TAKE_BUT_COMPLAIN'
}

export type ProtocolsPaginatedResult = {
  __typename?: 'ProtocolsPaginatedResult';
  items: Array<Protocol>;
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  calendarEvent: CalendarEvent;
  calendarEventPaginated: CalendarEventsPaginatedResult;
  calendarEventParticipant: CalendarEventParticipant;
  calendarEventParticipantPaginated: CalendarEventParticipantsPaginatedResult;
  calendarEventParticipants: Array<CalendarEventParticipant>;
  calendarEvents: Array<CalendarEvent>;
  complain: Complain;
  complainPaginated: ComplainsPaginatedResult;
  complains: Array<Complain>;
  contract: Contract;
  contractPaginated: ContractsPaginatedResult;
  contracts: Array<Contract>;
  customItem: CustomItem;
  customItemPaginated: CustomItemsPaginatedResult;
  customItems: Array<CustomItem>;
  customer: Customer;
  customerPaginated: CustomersPaginatedResult;
  customers: Array<Customer>;
  electronic: Electronic;
  electronicOrderPrice: ElectronicOrderPrice;
  electronicOrderPricePaginated: ElectronicOrderPricesPaginatedResult;
  electronicOrderPrices: Array<ElectronicOrderPrice>;
  electronicPaginated: ElectronicsPaginatedResult;
  electronics: Array<Electronic>;
  finance: Finance;
  financePaginated: FinancesPaginatedResult;
  finances: Array<Finance>;
  furniture: Furniture;
  furnitureOrderPrice: FurnitureOrderPrice;
  furnitureOrderPricePaginated: FurnitureOrderPricesPaginatedResult;
  furnitureOrderPrices: Array<FurnitureOrderPrice>;
  furniturePaginated: FurnituresPaginatedResult;
  furnitures: Array<Furniture>;
  getOrganizationUsers: ZitadelUserResponse;
  myCalendarEvents: Array<CalendarEvent>;
  myNotifications: Array<Notification>;
  myReadNotifications: Array<Notification>;
  note: Note;
  notePaginated: NotesPaginatedResult;
  notes: Array<Note>;
  notification: Notification;
  notificationPaginated: NotificationsPaginatedResult;
  notificationRead: NotificationRead;
  notificationReadPaginated: NotificationReadsPaginatedResult;
  notificationReads: Array<NotificationRead>;
  notifications: Array<Notification>;
  order: Order;
  orderDocument: OrderDocument;
  orderDocumentPaginated: OrderDocumentsPaginatedResult;
  orderDocuments: Array<OrderDocument>;
  orderPaginated: OrdersPaginatedResult;
  orderPrice: OrderPrice;
  orderPricePaginated: OrderPricesPaginatedResult;
  orderPrices: Array<OrderPrice>;
  orderState: OrderState;
  orderStatePaginated: OrderStatesPaginatedResult;
  orderStates: Array<OrderState>;
  orders: Array<Order>;
  partner: Partner;
  partnerPaginated: PartnersPaginatedResult;
  partners: Array<Partner>;
  protocol: Protocol;
  protocolFieldExtension: ProtocolFieldExtension;
  protocolFieldExtensionPaginated: ProtocolFieldExtensionsPaginatedResult;
  protocolFieldExtensions: Array<ProtocolFieldExtension>;
  protocolPaginated: ProtocolsPaginatedResult;
  protocols: Array<Protocol>;
  service: Service;
  serviceOrderPrice: ServiceOrderPrice;
  serviceOrderPricePaginated: ServiceOrderPricesPaginatedResult;
  serviceOrderPrices: Array<ServiceOrderPrice>;
  servicePaginated: ServicesPaginatedResult;
  services: Array<Service>;
  task: Task;
  taskPaginated: TasksPaginatedResult;
  taskPreset: TaskPreset;
  taskPresetPaginated: TaskPresetsPaginatedResult;
  taskPresets: Array<TaskPreset>;
  tasks: Array<Task>;
  todo: Todo;
  todoPaginated: TodosPaginatedResult;
  todos: Array<Todo>;
};


export type QueryCalendarEventArgs = {
  id: Scalars['String']['input'];
};


export type QueryCalendarEventPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryCalendarEventParticipantArgs = {
  id: Scalars['String']['input'];
};


export type QueryCalendarEventParticipantPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryCalendarEventParticipantsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryCalendarEventsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryComplainArgs = {
  id: Scalars['String']['input'];
};


export type QueryComplainPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryComplainsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryContractArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryContractsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryCustomItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomItemPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryCustomItemsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryCustomerArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryElectronicArgs = {
  id: Scalars['String']['input'];
};


export type QueryElectronicOrderPriceArgs = {
  id: Scalars['String']['input'];
};


export type QueryElectronicOrderPricePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryElectronicOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryElectronicPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryElectronicsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryFinanceArgs = {
  id: Scalars['String']['input'];
};


export type QueryFinancePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryFinancesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryFurnitureArgs = {
  id: Scalars['String']['input'];
};


export type QueryFurnitureOrderPriceArgs = {
  id: Scalars['String']['input'];
};


export type QueryFurnitureOrderPricePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryFurnitureOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryFurniturePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryFurnituresArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryMyCalendarEventsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryMyNotificationsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryMyReadNotificationsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryNoteArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryNotesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryNotificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryNotificationReadArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationReadPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryNotificationReadsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryOrderArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrderDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrderDocumentPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryOrderDocumentsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryOrderPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryOrderPriceArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrderPricePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryOrderStateArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrderStatePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryOrderStatesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryPartnerArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryPartnersArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryProtocolArgs = {
  id: Scalars['String']['input'];
};


export type QueryProtocolFieldExtensionArgs = {
  id: Scalars['String']['input'];
};


export type QueryProtocolFieldExtensionPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryProtocolFieldExtensionsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryProtocolPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryProtocolsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryServiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceOrderPriceArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceOrderPricePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryServiceOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryServicePaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryServicesArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryTaskArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryTaskPresetArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskPresetPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryTaskPresetsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryTasksArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QueryTodoArgs = {
  id: Scalars['String']['input'];
};


export type QueryTodoPaginatedArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination: PaginationInput;
};


export type QueryTodosArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type ReadNotificationInput = {
  notification: Scalars['String']['input'];
};

export type Service = {
  __typename?: 'Service';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  sellerPrice?: Maybe<Scalars['Float']['output']>;
  serviceOrderPrices: Array<ServiceOrderPrice>;
  vatType?: Maybe<VatType>;
};


export type ServiceServiceOrderPricesArgs = {
  filter?: InputMaybe<FilterInput>;
};

export type ServiceChangeResult = {
  __typename?: 'ServiceChangeResult';
  payload: Service;
  type: EntityChangeType;
};

export type ServiceOrderPrice = {
  __typename?: 'ServiceOrderPrice';
  count?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  customItem?: Maybe<CustomItem>;
  discount?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderPrice: OrderPrice;
  organizationId: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  sellerPrice?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<Service>;
  vatType?: Maybe<VatType>;
};

export type ServiceOrderPriceChangeResult = {
  __typename?: 'ServiceOrderPriceChangeResult';
  payload: ServiceOrderPrice;
  type: EntityChangeType;
};

export type ServiceOrderPricesPaginatedResult = {
  __typename?: 'ServiceOrderPricesPaginatedResult';
  items: Array<ServiceOrderPrice>;
  pageInfo: PageInfo;
};

export type ServicesPaginatedResult = {
  __typename?: 'ServicesPaginatedResult';
  items: Array<Service>;
  pageInfo: PageInfo;
};

export type StoredFile = {
  __typename?: 'StoredFile';
  attachments: Array<StoredFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  calendareventChanged: CalendarEventChangeResult;
  calendareventparticipantChanged: CalendarEventParticipantChangeResult;
  complainChanged: ComplainChangeResult;
  contractChanged: ContractChangeResult;
  customerChanged: CustomerChangeResult;
  customitemChanged: CustomItemChangeResult;
  electronicChanged: ElectronicChangeResult;
  electronicorderpriceChanged: ElectronicOrderPriceChangeResult;
  financeChanged: FinanceChangeResult;
  furnitureChanged: FurnitureChangeResult;
  furnitureorderpriceChanged: FurnitureOrderPriceChangeResult;
  noteChanged: NoteChangeResult;
  notificationChanged: NotificationChangeResult;
  notificationCreated: Notification;
  notificationreadChanged: NotificationReadChangeResult;
  orderChanged: OrderChangeResult;
  orderdocumentChanged: OrderDocumentChangeResult;
  orderpriceChanged: OrderPriceChangeResult;
  orderstateChanged: OrderStateChangeResult;
  partnerChanged: PartnerChangeResult;
  protocolChanged: ProtocolChangeResult;
  protocolfieldextensionChanged: ProtocolFieldExtensionChangeResult;
  serviceChanged: ServiceChangeResult;
  serviceorderpriceChanged: ServiceOrderPriceChangeResult;
  taskChanged: TaskChangeResult;
  taskpresetChanged: TaskPresetChangeResult;
  todoChanged: TodoChangeResult;
};


export type SubscriptionCalendareventChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionCalendareventparticipantChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionComplainChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionContractChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionCustomerChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionCustomitemChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionElectronicChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionElectronicorderpriceChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionFinanceChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionFurnitureChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionFurnitureorderpriceChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionNoteChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionNotificationChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionNotificationreadChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionOrderChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionOrderdocumentChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionOrderpriceChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionOrderstateChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionPartnerChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionProtocolChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionProtocolfieldextensionChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionServiceChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionServiceorderpriceChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionTaskChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionTaskpresetChangedArgs = {
  entityId: Scalars['String']['input'];
};


export type SubscriptionTodoChangedArgs = {
  entityId: Scalars['String']['input'];
};

export type Task = {
  __typename?: 'Task';
  assignees?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  due: Scalars['DateTime']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  organizationId: Scalars['String']['output'];
  priority: TaskPriority;
  resolved: Scalars['Boolean']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  state: TaskState;
};

export type TaskChangeResult = {
  __typename?: 'TaskChangeResult';
  payload: Task;
  type: EntityChangeType;
};

export type TaskPreset = {
  __typename?: 'TaskPreset';
  assignees?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dayOffset: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderState: OrderState;
  organizationId: Scalars['String']['output'];
  priority: TaskPriority;
};

export type TaskPresetChangeResult = {
  __typename?: 'TaskPresetChangeResult';
  payload: TaskPreset;
  type: EntityChangeType;
};

export type TaskPresetsPaginatedResult = {
  __typename?: 'TaskPresetsPaginatedResult';
  items: Array<TaskPreset>;
  pageInfo: PageInfo;
};

export enum TaskPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum TaskState {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  ToBePrepared = 'TO_BE_PREPARED'
}

export type TasksPaginatedResult = {
  __typename?: 'TasksPaginatedResult';
  items: Array<Task>;
  pageInfo: PageInfo;
};

export type Todo = {
  __typename?: 'Todo';
  completed?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  order: Order;
  organizationId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type TodoChangeResult = {
  __typename?: 'TodoChangeResult';
  payload: Todo;
  type: EntityChangeType;
};

export type TodosPaginatedResult = {
  __typename?: 'TodosPaginatedResult';
  items: Array<Todo>;
  pageInfo: PageInfo;
};

export type UpdateCalendarEventInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<CallendarEventPriority>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CallendarEventStatus>;
  type?: InputMaybe<CalendarEventType>;
};

export type UpdateCalendarEventParticipantInput = {
  calendarEvent?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  participantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateComplainInput = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  protocol?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractInput = {
  contractCode?: InputMaybe<Scalars['String']['input']>;
  customerCity?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerHouseNumber?: InputMaybe<Scalars['String']['input']>;
  customerIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerResponsiblePerson?: InputMaybe<Scalars['String']['input']>;
  customerStreet?: InputMaybe<Scalars['String']['input']>;
  customerZip?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  floorplanN1?: InputMaybe<Scalars['String']['input']>;
  floorplanN2?: InputMaybe<Scalars['String']['input']>;
  floorplanN3?: InputMaybe<Scalars['String']['input']>;
  floorplanN4?: InputMaybe<Scalars['String']['input']>;
  formOfPayment?: InputMaybe<PaymentType>;
  id: Scalars['String']['input'];
  maxDeliveryDays?: InputMaybe<Scalars['Float']['input']>;
  obligationAssembleElectronicsFromThem?: InputMaybe<Scalars['Boolean']['input']>;
  obligationDeliverAssembleElectronicsFromUs?: InputMaybe<Scalars['Boolean']['input']>;
  obligationDeliverAssembleFurnitureFromUs?: InputMaybe<Scalars['Boolean']['input']>;
  orderCity?: InputMaybe<Scalars['String']['input']>;
  orderHouseNumber?: InputMaybe<Scalars['String']['input']>;
  orderName?: InputMaybe<Scalars['String']['input']>;
  orderStreet?: InputMaybe<Scalars['String']['input']>;
  orderZip?: InputMaybe<Scalars['String']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  visualisationN1?: InputMaybe<Scalars['String']['input']>;
  visualisationN2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomItemInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type UpdateCustomerInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateElectronicInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type UpdateElectronicOrderPriceInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  customItem?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  electronic?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderPrice?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type UpdateFinanceInput = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  expenditure?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  income?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFurnitureInput = {
  id: Scalars['String']['input'];
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productLine?: InputMaybe<Scalars['String']['input']>;
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
  withoutDiscount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFurnitureOrderPriceInput = {
  atypicalTax?: InputMaybe<Scalars['Float']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  customItem?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  furniture?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderPrice?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productLine?: InputMaybe<Scalars['String']['input']>;
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
  withoutDiscount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNoteInput = {
  customer?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationInput = {
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
};

export type UpdateNotificationReadInput = {
  id: Scalars['String']['input'];
  notification?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderDocumentInput = {
  category: OrderDocumentCategory;
  id: Scalars['String']['input'];
};

export type UpdateOrderInput = {
  assembly?: InputMaybe<Scalars['Boolean']['input']>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  carpenter?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  dateOfDelivery?: InputMaybe<Scalars['String']['input']>;
  dateOfInstalation?: InputMaybe<Scalars['String']['input']>;
  dateOfOrder?: InputMaybe<Scalars['String']['input']>;
  dateOfRealization?: InputMaybe<Scalars['String']['input']>;
  dateOfSignature?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfSurvey?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownAppliance?: InputMaybe<Scalars['Boolean']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  preliminaryBudget?: InputMaybe<Scalars['Float']['input']>;
  seller?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderPriceInput = {
  backsplashDecor?: InputMaybe<Scalars['String']['input']>;
  colorOfCorpus?: InputMaybe<Scalars['String']['input']>;
  colorOfDoors?: InputMaybe<Scalars['String']['input']>;
  corpusDecor?: InputMaybe<Scalars['String']['input']>;
  corpusMaterial?: InputMaybe<Scalars['String']['input']>;
  discountFurniture?: InputMaybe<Scalars['String']['input']>;
  doorDecor?: InputMaybe<Scalars['String']['input']>;
  doorMaterial?: InputMaybe<Scalars['String']['input']>;
  furnitureSectionName?: InputMaybe<Scalars['String']['input']>;
  handle1Type?: InputMaybe<Scalars['String']['input']>;
  handle2Type?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  socketType?: InputMaybe<Scalars['String']['input']>;
  socleHeight?: InputMaybe<Scalars['String']['input']>;
  worktopDecor?: InputMaybe<Scalars['String']['input']>;
  worktopType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderStateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  dashboardIndex?: InputMaybe<Scalars['Int']['input']>;
  finalState?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  visibleForConstructer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePartnerInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProtocolFieldExtensionInput = {
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FieldType>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProtocolInput = {
  accesoriesMatchesContract?: InputMaybe<Scalars['Boolean']['input']>;
  carpenterAfterSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  carpenterBeforeSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  cleanUpIsCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  colorMatchesContract?: InputMaybe<Scalars['Boolean']['input']>;
  customerAfterSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerBeforeSignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  damagedFloor?: InputMaybe<Scalars['Boolean']['input']>;
  damagedGear?: InputMaybe<Scalars['Boolean']['input']>;
  damagedWalls?: InputMaybe<Scalars['Boolean']['input']>;
  fumeHoodIsCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  furnitureSetupIsComplete?: InputMaybe<Scalars['Boolean']['input']>;
  halfTimeOfSpaceIsEqual?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  instalationOfKitchenSetup?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  preparationOfElectroInstalationIsCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  protocolHandoverContractorState?: InputMaybe<ProtocolHandoverContractorState>;
  protocolResultState?: InputMaybe<ProtocolResultState>;
  visuallyOk?: InputMaybe<Scalars['Boolean']['input']>;
  waterAndWasteOutletIsCorrect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateServiceInput = {
  id: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type UpdateServiceOrderPriceInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  customItem?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderPrice?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sellerPrice?: InputMaybe<Scalars['Float']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  vatType?: InputMaybe<VatType>;
};

export type UpdateTaskInput = {
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  due?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TaskPriority>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<TaskState>;
};

export type UpdateTaskPresetInput = {
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  dayOffset?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderState?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<TaskPriority>;
};

export type UpdateTodoInput = {
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum VatType {
  Full = 'FULL',
  Half = 'HALF'
}

export type ZitadelUserDetails = {
  __typename?: 'ZitadelUserDetails';
  changeDate: Scalars['String']['output'];
  resourceOwner: Scalars['String']['output'];
  sequence: Scalars['String']['output'];
};

export type ZitadelUserEntity = {
  __typename?: 'ZitadelUserEntity';
  details: ZitadelUserDetails;
  loginNames: Array<Scalars['String']['output']>;
  machine: ZitadelUserMachine;
  preferredLoginName: Scalars['String']['output'];
  state: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ZitadelUserMachine = {
  __typename?: 'ZitadelUserMachine';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ZitadelUserResponse = {
  __typename?: 'ZitadelUserResponse';
  details: ZitadelUserResponseDetails;
  result: Array<ZitadelUserEntity>;
};

export type ZitadelUserResponseDetails = {
  __typename?: 'ZitadelUserResponseDetails';
  timestamp: Scalars['String']['output'];
  totalResult: Scalars['String']['output'];
};
